
export default () => ({
    
    trackCallClick(number) {

        if (typeof dataLayer !== 'undefined') {
            // dataLayer.push({
            //     'event': 'call_link_click',
            //     'link_text': number,
            //     'link_type': 'tel'
            // });
        }
    }
});